import { combineReducers } from '@reduxjs/toolkit'

import loginReducer from './login'
import tenantsReducer from './tenants'
import adminReducer from './admins'
import themeReducer from './theme'
import currencyReducer from './currencies'
import fetchReducer from './fetchData'
import tenantsFetchDataReducer from './tenantsFetchData'
import credentialsReducer from './tenantcredentials'
import tenantUsersReducer from './tenantUsers'
import adminUserReducer from './adminUser'
import tenantAffiliatesReducer from './tenantAffiliates'
import tenantCasinoReducer from './tenantCasino'
import superAdminCasinoManagementReducer from './superAdminCasinoManagement'
import superAdminTransactionReducer from './superAdminTransactions'
import tenantTransactionReducer from './tenantTransactions'
import bonusReducer from './bonus'
import superAdminSettingsReducer from './superAdminSettings'
import dashboardReducer from './dashboard'
import wageringTemplateReducer from './wageringTemplate'
import emailTemplateReducer from './emailTemplate'
import languageReducer from './languages'
import paymentReducer from './payment'
import betSettingsReducer from './betSettingsSlice'
import sportsBookReducer from './sportsBook'
import userReducer from './userSlice'
import notificationReducer from './notificationSlice'
import transactionDriversReducer from './transactionDriversSlice'
import staffReducer from './staffSlice'
import promoCodesReducer from './promoCodesSlice'
import voucherCodesReducer from './voucherCodesSlice'
import uploadApkReducer from './uploadApk'

const appReducer = combineReducers({
  login: loginReducer,
  tenants: tenantsReducer,
  admins: adminReducer,
  staff: staffReducer,
  theme: themeReducer,
  currencies: currencyReducer,
  tenantsFetch: tenantsFetchDataReducer,
  fetch: fetchReducer,
  users: userReducer,
  notifications: notificationReducer,
  tenantcredentials: credentialsReducer,
  tenantUsers: tenantUsersReducer,
  adminUser: adminUserReducer,
  tenantAffiliate: tenantAffiliatesReducer,
  tenantCasino: tenantCasinoReducer,
  superAdminCasino: superAdminCasinoManagementReducer,
  superAdminTransactions: superAdminTransactionReducer,
  tenantTransactions: tenantTransactionReducer,
  bonus: bonusReducer,
  superAdminSettings: superAdminSettingsReducer,
  dashboard: dashboardReducer,
  wageringTemplate: wageringTemplateReducer,
  emailTemplate: emailTemplateReducer,
  languages: languageReducer,
  payment: paymentReducer,
  betSettings: betSettingsReducer,
  sportsBook: sportsBookReducer,
  transactionDrivers: transactionDriversReducer,
  promoCodes: promoCodesReducer,
  voucherCodes: voucherCodesReducer,
  uploadApk: uploadApkReducer
})

export const resetState = () => ({
  type: 'resetState'
})

const rootReducer = (state, action) => {
  if (action.type === 'resetState') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}

export default rootReducer
